import React from 'react';
import { AlertTriangleOutline, SuccessCircleOutline, LoadingOutline } from '@olist/design-system-icons';
import { isValidElementType } from 'react-is';
import { FeedbackIcon } from './styles.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const feedbackIcon = {
    error: React.createElement(AlertTriangleOutline, null),
    valid: React.createElement(SuccessCircleOutline, null),
};
const SuprefixContent = ({ el: El, isLoading, feedback, hasInteractiveEl, showFeedbackIcon = true, }) => {
    return (React.createElement(React.Fragment, null, hasInteractiveEl ? (React.createElement(FeedbackIcon, { isLoading: isLoading, feedback: feedback, "aria-hidden": "true" }, isLoading ? (React.createElement(LoadingOutline, null)) : (feedback && showFeedbackIcon && feedbackIcon[feedback]))) : El && isValidElementType(El) && typeof El !== 'string' ? (React.createElement(El, { "aria-hidden": "true" })) : (React.createElement(ParagraphMd, { as: "span", style: { lineHeight: 'unset' } }, El))));
};

export { SuprefixContent };
